import { useMemo } from 'react';

import {Response, Props} from "components/widgets/RiskRegister/components/SegmentCell/SegmentCell.logic.types";

export const useSegmentCellLogic = ({ activitiesByKey, linkOption, api }: Props): Response => {
    const options = {
        wbs: 'WBS',
        activityCodes: 'Activity code',
        cluster: 'Cluster',
        specific: 'Specific tasks',
        segment: 'Segment',
        all: 'All project activities',
    };

    const title = options[linkOption];

    const specific = api.getSpecificActivities.data;
    const wbs = api.getWbs.data;
    const activityCodes = api.getActivityCodes.data;
    const cluster = api.getCluster.data;

    const value = useMemo(() => {
        switch (linkOption) {
            case 'specific':
                return (
                    specific
                        ?.filter((item) => activitiesByKey.specific?.includes(item.taskVersionHashCode))
                        .map(
                            (item) =>
                                `${item.name} (ID: ${item.activityId.length > 20 ? item.activityId.slice(0, 20) + '...' : item.activityId})`,
                        ) || null
                );
            case 'wbs':
                const wbsItem = wbs?.find((item) => item.id === activitiesByKey.wbs);
                if (wbsItem) {
                    return `${wbsItem.name} (ID: ${wbsItem.activity_id})`;
                }
                return activitiesByKey.wbs;
            case 'cluster':
                const clusterItem = cluster?.clusterList.find((item) => item.clusterId === activitiesByKey.cluster);
                if (clusterItem) {
                    return clusterItem.clusterName;
                }
                return activitiesByKey.cluster;
            case 'activityCodes':
                return (
                    activityCodes
                        ?.filter((item) => activitiesByKey.activityCodes?.includes(item.uid))
                        .map((item) =>
                            item.alias
                                ? `${item.alias}: ${item.description}`
                                : `${item.scope}: ${item.typeName}: ${item.description}`,
                        ) || null
                );
            case 'segment':
                return activitiesByKey.segment;
            case 'all':
                return '';
            default:
                return 'N/A';
        }
    }, [linkOption, specific, wbs, activityCodes, cluster, activitiesByKey.segment]);
    return <Response>{
        selectedLinkOption: linkOption,
        title,
        value,
    };
};


